import { createSlice } from "@reduxjs/toolkit";
//currently not in use keep for further refrence
const initialState = {
  clientStatementList: { loading: false, data: null, error: null },
};

export const ClientStatementSlice = createSlice({
  name: "clientStatement",
  initialState,
  reducers: {
    fetchclientStatementListRequest: (state, action) => {
      state.clientStatementList.loading = true;
      state.clientStatementList.error = null;
    },
    fetchclientStatementListSuccess: (state, action) => {
      state.clientStatementList.data = action.payload;
      state.clientStatementList.loading = false;
      state.clientStatementList.error = null;
    },
    fetchclientStatementListFailure: (state, action) => {
      state.clientStatementList.data = null;
      state.clientStatementList.loading = false;
      state.clientStatementList.error = action.payload;
    },
  },
});

export const {
  fetchclientStatementListRequest,
  fetchclientStatementListSuccess,
  fetchclientStatementListFailure,
} = ClientStatementSlice.actions;

export default ClientStatementSlice.reducer;